$(function() {
    $('.filter__more').on('click', function(event) {
        showMoreOption($('.more-options'));
    });

    $('.more-options__clear-all').on('click', function(event) {
        event.preventDefault();
        var inputArr = $(this).closest('.more-options__body').find('input');
        inputArr.each(function(index, el) {
            if ($(el)[0].checked) {
                $(el).trigger('click');
            }
        });
    });
    $('.more-options .btn').on('click', function(event) {
        event.preventDefault();
        if ( $('.more-options').attr('data-page') === '/' ) {
            $('[data-search-page-url]').click();
        } else {
            closeMoreOption($('.more-options'));
        }
    });
})

function showMoreOption(popup) {
    var close = $(popup).find('.more-options__close');
    $('body').addClass('no-scroll');
    popup.fadeIn();

    popup.on('click', function(event) {
        if (!event.target.closest('.more-options__body')) {
            popup.fadeOut();
            $('body').removeClass('no-scroll');
        }
    });
    close.on('click', function(event) {
        closeMoreOption(popup);
    });

}

function closeMoreOption(popup) {
    $('body').removeClass('no-scroll');
    popup.fadeOut();
}
